export enum SideNavRouteEnum {
	DEFAULT = "DEFAULT",
	ADMIN_DEV = "ADMIN_DEV",
	ADMIN_HOTLINE = "ADMIN_HOTLINE",
	ADMIN_MARKET = "ADMIN_MARKET",
}
